export const createPortalWrapper = () => {
  const el = document.createElement('div');
  el.id = 'veda-portal-wrapper';
  return el;
};
